import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { Row, Form, Col, Input, Button, FormGroup } from 'reactstrap';
import QueueService from 'views/Queue/service';
import { ErrorMessage } from '@hookform/error-message';
import Modal from '../../../../../components/Modal/DefaultModal';
import { useDialogTree } from '../../tree/context';
import FlexSelect from 'components/Inputs/FlexSelect';
import { toast } from 'react-toastify';
import CreatableSelect from 'react-select/creatable';
import FormTooltip from 'components/Inputs/FormTooltip';
import Tour from 'reactour';
import { steps } from '../../tree/utils/steps';
import { loopTreeData } from '../../tree/context/helpers';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';
import { v4 as uuid } from 'uuid';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useRecordTypesByUser } from '../../../../RecordType/hooks/useRecordTypesByUser';
import { ProtocolFieldsBroadcastList } from '../../../../ChatBroadcastList/form/components/ProtocoloFields/ProtocolFieldsBrosdcastList';
import { FaNetworkWired } from 'react-icons/fa';
import { FiLink2, FiSend } from 'react-icons/fi';
import getFlexIAType from 'views/FlexIA/utils/getFlexIAType';
import FlexIAService from 'views/FlexIA/service/index';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import ChatDialogTreeService from '../../../service';
import { FlexMediaPreviewer } from 'components/FlexMediaPreviewer';
import { whenToSendImageOptions } from 'views/PredefinedMessage/utils/getImageSendOptions';
import { useUsers } from 'views/Report/Protocol/hooks/useUsers';
import ModalConfirmation from 'components/Modal/ConfirmationModal';
import { handleFilterFlexiaByType } from 'utils/fuctions/handleFilterFlexiaByType';

const DialogTreeModal = ({
  isOpenModal,
  onModalToggle,
  onSubmitModalData,
  selectedNode,
  flexiaId
}) => {
  const { userList } = useUsers();
  const [nodeActions, setNodeActions] = useState([]);
  const [flexiaList, setFlexiaList] = useState([]);
  const [flexiaListAll, setFlexiaListAll] = useState([]);
  const [queues, setQueues] = useState(null);
  const [tourOpen, setTourOpen] = useState(false);
  const [selectedFlexiaToTransfer, setSelectedFlexiaToTransfer] =
    useState(undefined);
  const [fields, setFields] = useState([
    {
      name: '',
      type: [],
      value: ''
    }
  ]);

  const [conditions, setConditions] = useState([
    {
      id: uuid(),
      validationString: '',
      type: ''
    }
  ]);

  const [elseCondition, setElseCondition] = useState({
    id: uuid(),
    validationString: 'else',
    type: ''
  });
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const [params, setParams] = useState([
    {
      paramName: '',
      paramValue: ''
    }
  ]);

  const [selectedRecordType, setSelectedRecordType] = useState();
  const { recordTypes, getRecordTypesByUser } = useRecordTypesByUser(
    entitiesName.PROTOCOL
  );

  const allowedTypesToSendMedia = ['ET', 'EE', 'TTW', 'SEND_AWAIT'];

  const [selectedFile, setSelectedFile] = useState(null);
  const [previewCover, setPreviewCover] = useState(null);
  const [chooseSendMedia, setChooseSendMedia] = useState(false);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [nodeValues, setNodeValues] = useState({});
  const [shouldDeleteChildrenNodes, setShouldDeleteChildrenNodes] =
    useState(false);
  const [shouldUseAttendantVariable, setShouldUseAttendantVariable] =
    useState(false);
  const systemConfiguration = useSelector((stt) => stt.systemConfiguration);

  useEffect(() => {
    if (isOpenModal === true) {
      getRecordTypesByUser();

      if (selectedNode.sendMedia && selectedNode.filepath) {
        setChooseSendMedia(selectedNode.sendMedia);
        setSelectedFile(selectedNode.filepath);
      }
    }
  }, [getRecordTypesByUser, isOpenModal, selectedNode]);

  const getSelectOptionsDTO = () => {
    if (!recordTypes) return [];
    return recordTypes.map((group) => ({
      label: group.name,
      value: group.id
    }));
  };

  const {
    reset,
    control,
    handleSubmit,
    errors,
    setValue,
    getValues,
    setError,
    watch
  } = useForm();
  const { treeData, typeNodeAction, setAvailableActions, setAvailableQueues } =
    useDialogTree();

  const [actionType, setActionType] = useState(null);

  const [chooseNodeQueue, setChooseNodeQueue] = useState(false);

  const [mandatoryMessage, setMandatoryMessage] = useState(false);

  const [awaitReply, setAwaitReply] = useState(true);

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  useEffect(() => {
    if (isOpenModal === true) {
      setChooseNodeQueue(
        (selectedNode?.queueId ?? selectedNode?.nodeQueue) != undefined &&
          typeNodeAction === 'EDIT_NODE'
      );
      setValue('chooseNodeQueue', chooseNodeQueue);

      setMandatoryMessage(selectedNode?.mandatoryMessage ?? false);
      setValue('mandatoryMessage', selectedNode?.mandatoryMessage ?? false);
      setValue('userVariableValue', selectedNode?.userVariableValue ?? '');
      setValue(
        'defaultQueueVariable',
        selectedNode?.defaultQueueVariable ?? ''
      );
      setAwaitReply(selectedNode?.awaitReply ?? true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModal]);

  useEffect(() => {
    setAvailableActions(nodeActions);
    setAvailableQueues(queues);
  }, [nodeActions, queues, setAvailableActions, setAvailableQueues]);

  useEffect(() => {
    FlexChatIntegration.getActionDialogTree()
      .then((response) => {
        setNodeActions(response.data);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao carregar as ações do nó');
      });
  }, []);

  useEffect(() => {
    if (!isOpenModal) return;

    if (typeNodeAction === 'EDIT_NODE' && selectedNode) {
      setSelectedRecordType(selectedNode?.action?.protocol?.recordTypeId ?? 1);
      setSelectedFlexiaToTransfer(selectedNode?.action?.flexiaConfig?.id);

      let protocol = {};
      if (selectedNode?.action?.protocol) {
        Object.keys(selectedNode.action.protocol).forEach((key) => {
          protocol[key] = {
            label: key,
            value: selectedNode.action.protocol[key]
          };
        });
        reset({ protocol });
      }

      setActionType(selectedNode?.action?.type);

      selectedNode.variables?.length > 0
        ? setFields(
            selectedNode?.variables.map((e) => {
              let value;
              switch (e.type) {
                case 'DELETE_VALUE':
                  value = 'null';
                  break;
                case 'INSERT_VALUE':
                  value = 'input.message';
                  break;
                case 'DEFINE_VALUE':
                  value = e.value;
                  break;
                default:
                  value = e.value;
              }
              return { ...e, value: value };
            })
          )
        : setFields([{ name: '', type: [], value: '' }]);

      setConditions(
        selectedNode?.conditionSettings?.conditions?.map((e) => ({ ...e })) ?? [
          { id: uuid(), validationString: '', type: '' }
        ]
      );

      setElseCondition(
        selectedNode?.conditionSettings?.else ?? {
          id: uuid(),
          validationString: 'else',
          type: ''
        }
      );

      selectedNode.params?.length > 0
        ? setParams(selectedNode?.params)
        : setParams([{ paramName: '', paramValue: '' }]);

      setShouldUseAttendantVariable(selectedNode?.shouldUseAttendantVariable);
      setMandatoryMessage(selectedNode?.mandatoryMessage ?? false);

      setChooseNodeQueue(
        (selectedNode?.queueId ?? selectedNode?.nodeQueue) !== undefined
      );
    } else {
      setActionType(null);
      setFields([{ name: '', type: [], value: '' }]);
      setConditions([{ id: uuid(), validationString: '', type: '' }]);
      setElseCondition({ id: uuid(), validationString: 'else', type: '' });
      setParams([{ paramName: '', paramValue: '' }]);

      setChooseNodeQueue(false);
      setMandatoryMessage(false);
      setShouldUseAttendantVariable(false);
      setSelectedRecordType(1);
      setSelectedFlexiaToTransfer(undefined);
      setSelectedFile(null);
      setPreviewCover(null);
      setChooseSendMedia(false);
    }
  }, [selectedNode, typeNodeAction, isOpenModal, reset]);

  const getQueues = useCallback(async () => {
    QueueService.getAll()
      .then((response) => {
        const queuesData = response.data.data;
        if (queuesData) {
          const queues = queuesData.map(({ id, name }) => ({ id, name }));
          setQueues(queues);
        }
      })
      .catch(() => {
        toast('Ocorreu um erro ao carregar as filas');
      });
  }, []);

  useEffect(() => {
    getQueues();
  }, [getQueues]);

  const handleUpdateAccountsInBatch = (values) => {
    onSubmit(values);
  };

  const handleOpenModalConfirmation = () => {
    const values = getValues();
    if (
      selectedNode.action.type === 'CONDITIONAL_CHECK' &&
      values.action !== 'CONDITIONAL_CHECK'
    ) {
      setNodeValues(values);
      setOpenModalConfirmation(true);
      setShouldDeleteChildrenNodes(true);
    } else {
      onSubmit(values);
    }
  };

  const onSubmit = async (data) => {
    delete data.elseCondition;
    delete data.type;
    if (conditions.length > 0) {
      data.conditionSettings = {
        conditions: [...conditions],
        else: elseCondition
      };
    }

    if (
      (fields.length > 1 &&
        fields[fields.length - 1].name.length === 0 &&
        fields[fields.length - 1].type.length > 0) ||
      (fields.length > 1 &&
        fields[fields.length - 1].name.length === 0 &&
        fields[fields.length - 1].type.length === 0)
    ) {
      fields.pop();
    }

    if (fields[0].name.length > 0 && fields[0].type.length > 0) {
      data.variables = fields;
      data.hasVariable = true;
    } else {
      data.variables = [];
      data.hasVariable = false;
    }

    if (params[0].paramName.length > 1) {
      data.params = params;
      data.hasIntegration = true;
    } else {
      data.hasIntegration = false;
      data.params = [];
    }

    const action = {
      type: data.action,
      message: data.message
    };

    delete data.message;

    if (data.action === 'TRANSFER_TO_ATTENDANT') {
      data.shouldUseAttendantVariable = shouldUseAttendantVariable;

      if (!shouldUseAttendantVariable) {
        delete data.userVariableValue;
        delete data.defaultQueueVariable;
      }
    }

    if (data.action === 'LINKMENU') {
      action.to = {
        level: data.to
      };
      delete data.to;
    } else if (data.action === 'ET') {
      action.queue = data.queue;
      action.queueName = queues.find((queue) => queue.id === data.queue).name;
      delete data.queue;
    } else if (data.action === 'TTF') {
      action.flexiaConfig = {
        id: data.flexiaId,
        jumpInitial: data.WatsonJumpInitial === 'sim'
      };
      delete data.flexiaId;
      delete data.WatsonJumpInitial;
    }

    selectedNode.action = action;

    let currentNodes = [];

    Object.values(selectedNode.nodes).forEach((node) => {
      let hasConditionForThisNode = false;

      data.conditionSettings.conditions.forEach((condition) => {
        if (condition.id === node.nodeId || node.isDefault) {
          hasConditionForThisNode = true;
        }
      });

      if (hasConditionForThisNode || data.action.type !== 'CONDITIONAL_CHECK') {
        currentNodes.push(node);
      }
    });

    data.action = action;
    data.nodes = shouldDeleteChildrenNodes
      ? {}
      : Object.assign({}, currentNodes);

    if (selectedRecordType) {
      data.action.protocol = {
        recordTypeId: selectedRecordType
      };
      Object.keys(data?.protocol || {}).forEach((fieldName) => {
        data.action.protocol[fieldName] = data?.protocol[fieldName].value;
      });
      delete data.protocol;
    }

    delete data.variableType;

    if (data.stringIdentifier && data.action.type !== 'EXECUTE_INTEGRATION') {
      if (data.action === 'SUBMENU' || data.action === 'SUBMENU_BUTTONS') {
        const emojiRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        if (emojiRegex.exec(data.stringIdentifier)) {
          setError('stringIdentifier', {
            type: 'manual',
            message: 'Não é permitido emojis neste campo'
          });
          return;
        }
      }

      const possibleAnswersFormated = data.possibleAnswers?.reduce(
        (acc, { label }) => ({
          ...acc,
          [label.replace(/\s/g, '').toLowerCase().trim()]: {
            label: label
          }
        }),
        {}
      );
      data.possibleAnswers = possibleAnswersFormated;
    }

    if (chooseSendMedia === true) {
      if (selectedFile instanceof File) {
        const formatedFile = new FormData();
        formatedFile.append('file', selectedFile);

        await ChatDialogTreeService.addAttachment(formatedFile)
          .then((result) => {
            data.filepath = result.data.data.url;
            data.fileName = result.data.data.fileName;
          })
          .catch((err) =>
            toast.error(err || 'Ocorreu um erro ao salvar mídia no nó')
          );
      } else if (selectedNode.filepath && selectedNode.fileName) {
        data.filepath = selectedNode.filepath;
        data.fileName = selectedNode.fileName;
      }
    } else {
      data.filepath = null;
      data.fileName = null;
    }

    data.sendMedia = chooseSendMedia;

    if (shouldDeleteChildrenNodes) {
      data.nodes = {};
      data.shouldDeleteChildrenNodes = true;
    }

    onSubmitModalData(data);

    onModalToggle(false);
    setOpenModalConfirmation(false);
    setSelectedFile(null);
    setAwaitReply(false);
    setChooseSendMedia(false);
    reset();
  };

  const validarCondicional = (returnString) => {
    try {
      const variaveis = [...returnString.matchAll(/\$[a-zA-Z_]\w*/g)].map(
        (match) => match[0]
      );

      let variablesDeclaration = '';

      const declaredVariables = [];
      variaveis.forEach((variavel) => {
        if (!declaredVariables.includes(variavel)) {
          if (
            returnString[returnString.indexOf(variavel) + variavel.length] ===
            '?'
          ) {
            variablesDeclaration += `let ${variavel} = {};`;
          } else {
            variablesDeclaration += `let ${variavel} = "${variavel}";`;
          }
          declaredVariables.push(variavel);
        }
      });

      const funcString = `
      const now = (timezone) => new Date().toLocaleString("pt-BR", { timeZone: timezone}).split(' ')[1];

      const today = () => new Date().toISOString().split('T')[0];

      const day = () => today().split('-')[2];
      const month = () => today().split('-')[1];
      const year = () => today().split('-')[0];

      const dayOfWeek = () => new Date().getDay();

      const isAfterTime = (currentTime, targetTime) => {
        const [currentHours, currentMinutes, currentSeconds] = currentTime.split(':').map(Number);
        const [targetHours, targetMinutes, targetSeconds] = targetTime.split(':').map(Number);

        const currentTotalSeconds = currentHours * 3600 + currentMinutes * 60 + currentSeconds;
        const targetTotalSeconds = targetHours * 3600 + targetMinutes * 60 + targetSeconds;

        return currentTotalSeconds > targetTotalSeconds;
      };

      const isBeforeTime = (currentTime, targetTime) => {
        const [currentHours, currentMinutes, currentSeconds] = currentTime.split(':').map(Number);
        const [targetHours, targetMinutes, targetSeconds] = targetTime.split(':').map(Number);

        const currentTotalSeconds = currentHours * 3600 + currentMinutes * 60 + currentSeconds;
        const targetTotalSeconds = targetHours * 3600 + targetMinutes * 60 + targetSeconds;

        return currentTotalSeconds < targetTotalSeconds;
      };

      const isBetweenTime = (start, end, timezone) => {
        const nowTime = now(timezone ?? 'America/Fortaleza');
        return isAfterTime(nowTime, start) && isBeforeTime(nowTime, end);
      };

      const isAfterDate = (currentDate, targetDate) => {
        const current = new Date(\`\${currentDate}, 0:0:0\`);
        const target = new Date(\`\${targetDate}, 0:0:0\`);

        return current > target;
      };

      const isBeforeDate = (currentDate, targetDate) => {
        const current = new Date(\`\${currentDate}, 0:0:0\`);
        const target = new Date(\`\${targetDate}, 0:0:0\`);

        return current < target;
      };

      const firstDayOfMonth = (year, month) => {
        return \`\${year}-\${String(month).padStart(2, '0')}-01\`;
      };

      const lastDayOfMonth = (year, month) => {
        const lastDay = new Date(year, month, 0).getDate();
        return \`\${year}-\${String(month).padStart(2, '0')}-\${lastDay}\`;
      };

      const yesterday = () => {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d.toISOString().split('T')[0];
      };

      const tomorrow = () => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        return d.toISOString().split('T')[0];
      };

      const formatDate = (date, format) => {
        const d = new Date(\`\${date}, 0:0:0\`);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();

        return format
          .replace("dd", day)
          .replace("mm", month)
          .replace("yyyy", year);
      };

      const isWeekend = (date) => {
        const dayOfWeek = new Date(\`\${date}, 0:0:0\`).getDay();
        return dayOfWeek === 0 || dayOfWeek === 6;
      };

      const differenceInDays = (date1, date2) => {
        const d1 = new Date(\`\${date1}, 0:0:0\`);
        const d2 = new Date(\`\${date2}, 0:0:0\`);

        const diffInMs = Math.abs(d1 - d2);
        return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      };

      const nextBusinessDay = (date) => {
        const d = new Date(\`\${date}, 0:0:0\`);
        do {
          d.setDate(d.getDate() + 1);
        } while (d.getDay() === 0 || d.getDay() === 6);

        return d.toISOString().split('T')[0];
      };

      const isDateBetween = (date, startDate, endDate) => {
        const d = new Date(\`\${date}, 0:0:0\`);
        const start = new Date(startDate);
        const end = new Date(endDate);

        return d >= start && d <= end;
      };

      const isInDates = (dates) => {
        return dates.includes(today());
      };

      ${variablesDeclaration} return ${returnString}
      `;
      const func = new Function(funcString);
      const resultado = func();

      return typeof resultado === 'boolean';
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const getAvailableLevels = () => {
    const availableSubMenus = [];
    loopTreeData(treeData, (node) => {
      availableSubMenus.push(node);
    });

    return availableSubMenus.map((node) => {
      let action = nodeActions
        .filter((action) => action.type === node.action.type)
        .at(0);

      const nodeFatherId = node?.mac?.idMac;
      let parent;
      loopTreeData(treeData, (node) => {
        if (node.nodeId === nodeFatherId) {
          parent = node;
          return node;
        }
      });

      let technicalLabel = `${node.stringIdentifier} - level ${node.level}`;

      if (node.isDefault) {
        if (
          parent?.action.type === 'CONDITIONAL_CHECK' ||
          parent?.action.type === 'SUBMENU_BUTTONS'
        ) {
          technicalLabel = `Senão - level ${node.level}`;
        } else if (
          parent?.action.type === 'CREATE_PROTOCOL' ||
          parent?.action.type === 'EXECUTE_INTEGRATION' ||
          parent?.action.type === 'SEND_AWAIT'
        ) {
          technicalLabel = `Nó filho - level ${node.level}`;
        } else {
          technicalLabel = `Nó inicial - level ${node.level}`;
        }
      }

      let displayLabel = technicalLabel;

      if (node.nodeNameText && node.nodeNameText.trim() !== '') {
        displayLabel = `${node.nodeNameText} (${technicalLabel})`;
      }

      return {
        value: node.nodeId || '',
        optionSubtitle: action?.description || '',
        label: displayLabel || ''
      };
    });
  };

  const handleFilterActions = (isConditionalNode = false) => {
    let filteredActions = nodeActions;

    // get the father of this node
    const nodeFatherId = selectedNode?.mac?.idMac;
    let actualFatherNode = null;
    loopTreeData(treeData, (node) => {
      if (node.nodeId === nodeFatherId && nodeFatherId && node.isDefault) {
        actualFatherNode = node;
        return node;
      }
    });

    // if it have a father node, get the father of this node as well
    if (actualFatherNode) {
      const nodeGrandFatherId = actualFatherNode?.mac?.idMac;
      let actualGrandFatherNode = null;
      if (nodeGrandFatherId === null) {
        // if the father of this node doesn't have a father, it means that it is the nodes from level 1
        // if it is, we need to get how mane nodes are in level 1
        if (treeData && Object.keys(treeData).length === 1) {
          filteredActions = filteredActions.filter(
            (action) => action.type !== 'RETURN'
          );
        }
      }
      loopTreeData(treeData, (node) => {
        if (node.nodeId === nodeGrandFatherId && nodeGrandFatherId) {
          actualGrandFatherNode = node;
          return node;
        }
      });

      if (
        actualGrandFatherNode &&
        Object.keys(actualGrandFatherNode.nodes).length === 1
      ) {
        filteredActions = filteredActions.filter(
          (action) => action.type !== 'RETURN'
        );
      }
    }

    if (selectedNode.level === 1) {
      filteredActions = filteredActions.filter(
        (action) => action.type !== 'RETURN'
      );
    }

    if (
      typeNodeAction === 'EDIT_NODE' &&
      selectedNode.nodes &&
      ((Object.keys(selectedNode.nodes).length === 1 &&
        Object.keys(selectedNode.nodes[0]?.action ?? {}).length !== 0) ||
        Object.keys(selectedNode.nodes).length > 1) &&
      !isConditionalNode
    ) {
      filteredActions = filteredActions.filter(
        (action) => action.type === selectedNode.action.type
      );
    }

    const categories = [];

    return filteredActions.map((action) => {
      let icon;
      let category;
      let isDivisor = false;
      let label = action.description;

      if (!categories.includes(action.category)) {
        categories.push(action.category);
        isDivisor = true;
      }

      switch (action.category) {
        case 'FORWARDING':
          icon = <FiSend style={{ margin: '0px 0.5rem  0px 0px' }} />;
          category = 'Encaminhamento';
          break;
        case 'BRANCHES':
          icon = <FaNetworkWired style={{ margin: '0px 0.5rem  0px 0px' }} />;
          category = 'Ramificações e Interações';
          break;
        case 'INTEGRATIONS':
          icon = <FiLink2 style={{ margin: '0px 0.5rem  0px 0px' }} />;
          category = 'Integrações';
          break;
        default:
      }

      return {
        description: label,
        type: action.type,
        divisorCategory: isDivisor ? category : undefined,
        icon
      };
    });
  };

  const openTour = () => {
    setTourOpen(true);
  };

  useEffect(() => {
    FlexIAService.getAllFlexia(1, 100, '', { showDisable: false })
      .then((response) => {
        setFlexiaListAll(response.data.result);
        setFlexiaList(
          response.data.result.map((flexia) => {
            return {
              value: flexia.id,
              label: flexia.name,
              type: flexia.type,
              optionSubtitle: getFlexIAType(flexia.type || '')
            };
          })
        );
      })
      .catch((err) => {
        toast.error(
          (err.response && err.response.data.message) ||
            'Erro ao listar configurações da FlexIA!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      });
  }, []);

  const closeTour = () => {
    setTourOpen(false);
  };

  const onAddField = () => {
    const fieldValues = [...fields];
    fieldValues.push({
      name: '',
      type: [],
      value: ''
    });
    setFields(fieldValues);
  };

  const onAddFCondition = () => {
    const conditionValues = [...conditions];
    conditionValues.push({
      id: uuid(),
      validationString: '',
      type: ''
    });
    setConditions(conditionValues);
  };

  const onAddParam = () => {
    const paramValues = [...params];
    paramValues.push({
      paramName: '',
      paramValue: ''
    });
    setParams(paramValues);
  };

  const handleRemoveFields = (i) => {
    let values = [...fields];
    if (values.length > 1) {
      values.splice(i, 1);
    } else {
      values = [
        {
          name: '',
          type: [],
          value: ''
        }
      ];
    }
    setFields(values);
  };

  const handleRemoveConditions = (i) => {
    const values = [...conditions];
    if (values.length > 1) values.splice(i, 1);
    setConditions(values);
  };

  const handleRemoveParams = (i) => {
    const values = [...params];
    if (values.length > 1) values.splice(i, 1);
    setParams(values);
  };

  const handleChangeVariables = (index, field, value) => {
    const variables = [...fields];

    if (field === 'name') {
      variables[index].name = value;
    } else if (field === `type${index}`) {
      variables[index].value = value;

      if (value === 'null') {
        variables[index].type = 'DELETE_VALUE';
      } else if (value === 'input.message') {
        variables[index].type = 'INSERT_VALUE';
      } else {
        variables[index].type = 'DEFINE_VALUE';
      }
    }

    setFields(variables);
  };

  const handleChangeParams = (index, event) => {
    const values = [...params];
    if (event.target.name === 'paramName') {
      values[index].paramName = event.target.value;
    }

    if (event.target.name === 'paramValue') {
      values[index].paramValue = event.target.value;
    }

    setParams(values);
  };

  const handleChangeConditions = (index, event) => {
    const values = [...conditions];
    if (event.target.name === `validationString${index}`) {
      values[index].validationString = event.target.value;
    }

    setConditions(values);
  };

  const handleChangeConditionOptions = (index, value, name) => {
    const values = [...conditions];

    if (name === `type`) {
      values[index].type = value;
    }

    setConditions(values);
  };

  const unallowedActionTypes = ['CONDITIONAL_CHECK'];

  const changeFile = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setSelectedFile(file);
  };

  const handleClearFiles = async () => {
    if (selectedNode.sendMedia === true) {
      await ChatDialogTreeService.deleteAttachment(selectedNode.fileName)
        .then(() => {
          selectedNode.filepath = null;
          setSelectedFile(null);
        })
        .catch((err) =>
          toast.error(err || 'Ocorreu um erro ao salvar mídia no nó')
        );
    } else {
      setSelectedFile(null);
    }
  };

  const filterFlexIa = flexiaListAll.filter((flexia) => {
    return flexia.id !== flexiaId;
  });

  return (
    <>
      <Modal
        show={isOpenModal}
        onModalToggle={(state) => {
          onModalToggle(state);
        }}
        title="Configuração de Nó"
        showCloseButton={false}
        style={{ width: '90vw', maxWidth: ' 100rem' }}
      >
        <Form
          className="needs-validation"
          onSubmit={(event) => {
            event.stopPropagation();
            handleSubmit(onSubmit)(event);
          }}
        >
          <>
            <Row className="mb-3">
              <Col sm="6">
                <label className="form-control-label">
                  Nome do nó
                  <FormTooltip text="Nome do nó." />
                </label>
                <Controller
                  as={<Input type="text" placeholder="Nome do nó" />}
                  control={control}
                  name="nodeNameText"
                  defaultValue={
                    selectedNode?.nodeNameText && typeNodeAction === 'EDIT_NODE'
                      ? selectedNode?.nodeNameText
                      : ''
                  }
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm="6" md={actionType === 'CONDITIONAL_CHECK' ? '12' : '6'}>
                {selectedNode?.isDefault &&
                typeNodeAction !== 'ADD_NEW_NODE_CHILD' ? (
                  <></>
                ) : (
                  <>
                    <Row className="mb-3">
                      <Col sm="4" className="tour1-dt">
                        <label className="form-control-label">
                          Número
                          <FormTooltip text="Este número é opcional e representa a opção que será exibida ao usuário." />
                        </label>
                        <Controller
                          as={<Input type="number" min={1} />}
                          control={control}
                          name="numericIdentifier"
                          defaultValue={
                            selectedNode?.numericIdentifier &&
                            typeNodeAction === 'EDIT_NODE'
                              ? selectedNode?.numericIdentifier
                              : ''
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="numericIdentifier"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                      <Col sm="8" className="tour2-dt">
                        <label className="form-control-label">
                          Texto da opção*
                          <FormTooltip text="Este texto representa a descrição da opção que será apresentado ao usuário" />
                        </label>
                        <Controller
                          as={<Input />}
                          control={control}
                          name="stringIdentifier"
                          rules={{
                            required: 'Este campo é obrigatório'
                          }}
                          defaultValue={
                            selectedNode?.stringIdentifier &&
                            typeNodeAction === 'EDIT_NODE'
                              ? selectedNode?.stringIdentifier
                              : ''
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="stringIdentifier"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                    {actionType !== 'EXECUTE_INTEGRATION' && (
                      <Row className="mb-3">
                        <Col sm="12" className="tour3-dt">
                          <Row className="mb-3">
                            <Col sm="12">
                              <label className="form-control-label">
                                Respostas possíveis
                                <FormTooltip text="Este campo representa as possíveis respostas que, ao usuário digitar ativa a opção descrita neste nó." />
                              </label>
                              <Controller
                                render={(props) => (
                                  <CreatableSelect
                                    isMulti
                                    isClearable={true}
                                    options={[]}
                                    value={props.value}
                                    onChange={(value) => {
                                      props.onChange(value);
                                    }}
                                    placeholder="Selecione..."
                                    labelName="label"
                                    valueName="value"
                                  />
                                )}
                                control={control}
                                name="possibleAnswers"
                                rules={{ required: 'Campo obrigatório!' }}
                                defaultValue={() => {
                                  if (
                                    selectedNode?.possibleAnswers &&
                                    typeNodeAction === 'EDIT_NODE'
                                  ) {
                                    const possibleAnswers = Object.values(
                                      selectedNode?.possibleAnswers
                                    ).map(({ label }) => ({ label }));
                                    return possibleAnswers;
                                  }
                                  return [];
                                }}
                              />

                              <ErrorMessage
                                errors={errors}
                                name="possibleAnswers"
                                render={({ message }) =>
                                  errorFormMessage(message)
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
                <Row className="mb-3">
                  <Col
                    sm={actionType === 'EXECUTE_INTEGRATION' ? '6' : '12'}
                    md={actionType === 'EXECUTE_INTEGRATION' ? '6' : '12'}
                    className="tour4-dt"
                    style={{
                      paddingRight:
                        actionType === 'CONDITIONAL_CHECK' && '0.5rem'
                    }}
                  >
                    <label className="form-control-label">
                      Tipo da ação*
                      <FormTooltip text="Selecione o tipo de ação que será executada quando o usuário selecionar este nó." />
                    </label>
                    <Controller
                      render={(props) => (
                        <FlexSelect
                          isClearable={false}
                          dataOptions={handleFilterActions(true)}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value={props.value}
                          isDisabled={
                            selectedNode.parent?.action?.type ===
                              'CONDITIONAL_CHECK' &&
                            typeNodeAction === 'EDIT_NODE'
                          }
                          valueController={(fieldName, value) => {
                            setValue(fieldName, value);
                            setActionType(value);
                          }}
                          fieldName="action"
                          labelName="description"
                          valueName="type"
                        />
                      )}
                      control={control}
                      name="action"
                      rules={{ required: 'Campo obrigatório!' }}
                      defaultValue={
                        selectedNode?.action?.type &&
                        typeNodeAction === 'EDIT_NODE'
                          ? selectedNode?.action?.type
                          : ''
                      }
                    />

                    <ErrorMessage
                      errors={errors}
                      name="action"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>

                  {actionType === 'EXECUTE_INTEGRATION' && (
                    <Col sm="6" md="6" className="tour4-dt">
                      <label className="form-control-label">
                        Nome da função *
                        <FormTooltip text="Escreva o nome da função que existe no projeto integrations" />
                      </label>
                      <Controller
                        as={<Input />}
                        control={control}
                        name="integrationFunctionName"
                        rules={{ required: 'Campo obrigatório!' }}
                        defaultValue={
                          selectedNode?.integrationFunctionName &&
                          typeNodeAction === 'EDIT_NODE'
                            ? selectedNode?.integrationFunctionName
                            : ''
                        }
                      />
                      <ErrorMessage
                        errors={errors}
                        name="integrationFunctionName"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </Col>
                  )}
                </Row>
                {actionType === 'CONDITIONAL_CHECK' && (
                  <>
                    {conditions &&
                      conditions.map((data, i) => {
                        return (
                          <Row
                            style={{ alignItems: 'top', marginBottom: '1rem' }}
                            key={i}
                          >
                            <Col md="6" sm="6">
                              <label className="form-control-label">
                                Condição
                              </label>
                              <Controller
                                render={() => (
                                  <Input
                                    control={control}
                                    name={`validationString${i}`}
                                    value={data.validationString}
                                    onChange={(event) =>
                                      handleChangeConditions(i, event)
                                    }
                                  />
                                )}
                                rules={{
                                  validate: () => {
                                    if (
                                      !validarCondicional(
                                        conditions[i].validationString
                                      )
                                    ) {
                                      return 'Sintaxe inválida';
                                    }
                                  }
                                }}
                                control={control}
                                name={`validationString${i}`}
                                defaultValue=""
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`validationString${i}`}
                                render={({ message }) =>
                                  errorFormMessage(message)
                                }
                              />
                            </Col>
                            <Col md="5" sm="5">
                              <label className="form-control-label">Ação</label>
                              <Controller
                                render={() => (
                                  <FlexSelect
                                    isClearable={true}
                                    dataOptions={handleFilterActions(true)}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    value={data.type}
                                    valueController={(name, value) => {
                                      handleChangeConditionOptions(
                                        i,
                                        value,
                                        name
                                      );
                                    }}
                                    fieldName={`type`}
                                    labelName="description"
                                    valueName={`type`}
                                  />
                                )}
                                rules={{
                                  validate: () => {
                                    if (
                                      conditions[i].validationString.length >=
                                        1 &&
                                      conditions[i].type.length === 0
                                    ) {
                                      return 'A ação da condição é obrigatória';
                                    }
                                  }
                                }}
                                control={control}
                                name={`type`}
                                defaultValue=""
                              />
                              <ErrorMessage
                                errors={errors}
                                name={`type`}
                                render={({ message }) =>
                                  errorFormMessage(message)
                                }
                              />
                            </Col>
                            <Col
                              md="1"
                              sm="1"
                              style={{
                                padding: '2rem 0.4rem 0 0',
                                display: 'flex',
                                justifyContent: 'end',
                                height: '5rem'
                              }}
                            >
                              <Button
                                size="md"
                                color="danger"
                                onClick={() => handleRemoveConditions(i)}
                              >
                                <li className="fas fa-trash"></li>
                              </Button>
                            </Col>
                          </Row>
                        );
                      })}
                    <Row style={{ display: 'flex', justifyContent: 'end' }}>
                      <Button
                        style={{ marginTop: '1rem', marginRight: '0.4rem' }}
                        outline
                        type="button"
                        color="light"
                        onClick={onAddFCondition}
                      >
                        <li className="fas fa-plus"></li>
                      </Button>
                    </Row>
                    <Row style={{ alignItems: 'end', marginTop: '1rem' }}>
                      <Col md="6" sm="6" style={{ paddingRight: '0.4rem' }}>
                        <label className="form-control-label">Senão</label>
                        <Controller
                          render={() => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={handleFilterActions(true)}
                              isMulti={false}
                              closeMenuOnSelect={true}
                              value={elseCondition.type}
                              valueController={(_, value) => {
                                setElseCondition({
                                  id: elseCondition?.id ?? uuid(),
                                  validationString: 'else',
                                  type: value
                                });
                              }}
                              fieldName="elseCondition"
                              labelName="description"
                              valueName="type"
                            />
                          )}
                          rules={{
                            validate: () => {
                              if (
                                conditions[0].validationString.length > 0 &&
                                conditions[0].type.length > 0 &&
                                elseCondition.type.length === 0
                              ) {
                                return 'A ação da condição do senão é obrigatória';
                              }
                            }
                          }}
                          control={control}
                          name="elseCondition"
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="elseCondition"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {actionType === 'ET' ? (
                  <Row className="mb-3">
                    <Col sm="12">
                      <label className="form-control-label">
                        Fila*
                        <FormTooltip text="Selecione a fila para qual o usuário será transferido." />
                      </label>
                      <Controller
                        render={(props) => (
                          <FlexSelect
                            isClearable={true}
                            dataOptions={queues}
                            isMulti={false}
                            closeMenuOnSelect={true}
                            value={props.value}
                            valueController={setValue}
                            fieldName="queue"
                            labelName="name"
                            valueName="id"
                          />
                        )}
                        control={control}
                        name="queue"
                        rules={{ required: 'Campo obrigatório!' }}
                        defaultValue={
                          selectedNode?.action?.queue &&
                          typeNodeAction === 'EDIT_NODE'
                            ? selectedNode?.action?.queue
                            : ''
                        }
                      />

                      <ErrorMessage
                        errors={errors}
                        name="queue"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </Col>
                  </Row>
                ) : (
                  <></>
                )}

                {actionType === 'TRANSFER_TO_ATTENDANT' && (
                  <div>
                    <Row>
                      <Col sm="12" className="tour5-dt">
                        <div
                          style={{
                            marginLeft: '1.3rem',
                            marginTop: '0.5rem',
                            marginBottom: '0.3rem'
                          }}
                        >
                          <Controller
                            name="shouldUseAttendantVariable"
                            control={control}
                            render={(props) => (
                              <>
                                <label className="form-control-label">
                                  <Input
                                    type="checkbox"
                                    onChange={(e) => {
                                      setShouldUseAttendantVariable(
                                        e.target.checked
                                      );
                                      props.onChange(e.target.checked);
                                    }}
                                    checked={shouldUseAttendantVariable}
                                  />
                                  Usar atendente variável
                                </label>
                                <FormTooltip text="Quando o usuário passar por este nó, será transferido para o usuário ou fila que você configurar baseado na carteira de clientes." />
                              </>
                            )}
                            defaultValue={shouldUseAttendantVariable}
                          />
                        </div>
                      </Col>
                    </Row>

                    {!shouldUseAttendantVariable ? (
                      <Row className="mb-3">
                        <Col sm="12">
                          <label className="form-control-label">
                            Usuário*
                            <FormTooltip text="Selecione o atendente para qual o usuário será transferido." />
                          </label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                isClearable={true}
                                dataOptions={userList}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                value={props.value}
                                valueController={setValue}
                                fieldName="attendantLogin"
                                labelName="name"
                                valueName="login"
                              />
                            )}
                            control={control}
                            name="attendantLogin"
                            rules={
                              shouldUseAttendantVariable
                                ? {}
                                : { required: 'Campo obrigatório!' }
                            }
                            defaultValue={
                              selectedNode?.attendantLogin &&
                              typeNodeAction === 'EDIT_NODE'
                                ? selectedNode?.attendantLogin
                                : ''
                            }
                          />

                          <ErrorMessage
                            errors={errors}
                            name="attendantLogin"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Row
                          style={{
                            alignItems: 'start',
                            marginBottom: '1rem'
                          }}
                        >
                          <Col md="6" sm="6">
                            <label className="form-control-label">
                              Atendente
                              <FormTooltip text="Variável que será usada pra transferência para usuário variável" />
                            </label>
                            <Controller
                              as={<Input />}
                              control={control}
                              name="userVariableValue"
                              placeholder={'Ex.: $result.atendente'}
                              defaultValue={
                                selectedNode?.userVariableValue &&
                                typeNodeAction === 'EDIT_NODE'
                                  ? selectedNode?.userVariableValue
                                  : ''
                              }
                            />
                          </Col>

                          <Col md="6" sm="6">
                            <label className="form-control-label">
                              Fila
                              <FormTooltip text="Caso o cliente não esteja em nenhuma carteira, será transferido para essa fila" />
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={queues}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="defaultQueueVariable"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="defaultQueueVariable"
                              rules={{
                                required:
                                  shouldUseAttendantVariable == true
                                    ? 'Campo obrigatório!'
                                    : undefined
                              }}
                              defaultValue={
                                selectedNode?.defaultQueueVariable &&
                                typeNodeAction === 'EDIT_NODE'
                                  ? selectedNode?.defaultQueueVariable
                                  : ''
                              }
                            />
                          </Col>
                        </Row>
                        <Row
                          style={{
                            alignItems: 'start',
                            marginBottom: '1rem'
                          }}
                        >
                          <Col md="6" sm="6">
                            <label className="form-control-label">DDD</label>
                            <Controller
                              as={<Input />}
                              control={control}
                              name="dddVariableValue"
                              placeholder={'Ex.: 85'}
                              defaultValue={
                                selectedNode?.dddVariableValue &&
                                typeNodeAction === 'EDIT_NODE'
                                  ? selectedNode?.dddVariableValue
                                  : ''
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col sm="12">
                            <label className="form-control-label">
                              Tipo de transferência*
                              <FormTooltip text="Selecione se a transferência será como atribuído ou atendido." />
                            </label>
                            <Controller
                              name="typeOfTransfer"
                              control={control}
                              rules={{ required: 'Campo obrigatório!' }}
                              defaultValue={
                                selectedNode?.typeOfTransfer &&
                                typeNodeAction === 'EDIT_NODE'
                                  ? selectedNode?.typeOfTransfer
                                  : 'ASSIGNED'
                              }
                              render={(props) => (
                                <FlexSelect
                                  isClearable={false}
                                  dataOptions={[
                                    {
                                      value: 'ASSIGNED',
                                      label: 'Transferir como atribuído'
                                    },
                                    {
                                      value: 'ATTENDED',
                                      label: 'Transferir como atendido'
                                    }
                                  ]}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                  }}
                                  fieldName="typeOfTransfer"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="typeOfTransfer"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                )}

                {actionType === 'TTF' ? (
                  <>
                    <Row className="mb-3">
                      <Col sm="12">
                        <label className="form-control-label">
                          FlexIA*
                          <FormTooltip text="Selecione para qual FlexIA deseja transferir" />
                        </label>
                        <Controller
                          render={() => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={handleFilterFlexiaByType(
                                filterFlexIa
                              )}
                              isMulti={false}
                              closeMenuOnSelect={true}
                              value={selectedFlexiaToTransfer}
                              valueController={(name, value) => {
                                setSelectedFlexiaToTransfer(value);
                                setValue(name, value);
                              }}
                              fieldName="flexiaId"
                              labelName="label"
                              valueName="value"
                            />
                          )}
                          control={control}
                          name="flexiaId"
                          rules={{ required: 'Campo obrigatório!' }}
                          defaultValue={selectedFlexiaToTransfer}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="flexiaId"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                    {selectedFlexiaToTransfer !== undefined &&
                    flexiaList.filter((flexia) => {
                      return flexia.value === selectedFlexiaToTransfer;
                    })[0]?.type === 'WATSON' ? (
                      <Row className="mb-3">
                        <Col sm="12">
                          <label className="form-control-label">
                            Pular Mensagem Inicial*
                            <FormTooltip text="Ao selecionar esta opção a mensagem inicial do watson será ignorada e o valor enviado pelo cliente será repassado como resposta para a segunda pergunta do watson." />
                          </label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                isClearable={true}
                                dataOptions={[
                                  {
                                    label: 'Sim',
                                    value: 'sim'
                                  },
                                  {
                                    label: 'Não',
                                    value: 'nao'
                                  }
                                ]}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                value={props.value}
                                valueController={setValue}
                                fieldName="WatsonJumpInitial"
                                labelName="label"
                                valueName="value"
                              />
                            )}
                            control={control}
                            name="WatsonJumpInitial"
                            rules={{ required: 'Campo obrigatório!' }}
                            defaultValue={
                              selectedNode?.action?.flexiaConfig?.id &&
                              typeNodeAction === 'EDIT_NODE'
                                ? selectedNode?.action?.flexiaConfig
                                    ?.jumpInitial
                                  ? 'sim'
                                  : 'nao'
                                : ''
                            }
                          />

                          <ErrorMessage
                            errors={errors}
                            name="WatsonJumpInitial"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}
                {actionType === 'LINKMENU' ? (
                  <Row className="mb-3">
                    <Col sm="12">
                      <label className="form-control-label">
                        Para*
                        <FormTooltip
                          text={`Selecione o nível para qual o usuário será redirecionado dentro desta árvore.`}
                        />
                      </label>
                      <Controller
                        render={(props) => (
                          <FlexSelect
                            isClearable={true}
                            dataOptions={getAvailableLevels() || []}
                            isMulti={false}
                            closeMenuOnSelect={true}
                            value={props.value}
                            valueController={setValue}
                            fieldName="to"
                            labelName="label"
                            valueName="value"
                          />
                        )}
                        control={control}
                        name="to"
                        rules={{ required: 'Campo obrigatório!' }}
                        defaultValue={
                          selectedNode?.action?.to &&
                          typeNodeAction === 'EDIT_NODE'
                            ? String(selectedNode?.action?.to?.level)
                            : ''
                        }
                      />

                      <ErrorMessage
                        errors={errors}
                        name="to"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </Col>
                  </Row>
                ) : (
                  <></>
                )}
                {['SEND_AWAIT'].includes(actionType) && (
                  <>
                    <div
                      style={{
                        marginLeft: '1.3rem',
                        marginTop: '0.5rem',
                        marginBottom: '0.3rem'
                      }}
                    >
                      <Controller
                        name="awaitReply"
                        control={control}
                        render={(props) => (
                          <>
                            <label className="form-control-label">
                              <Input
                                type="checkbox"
                                onChange={(e) => {
                                  setAwaitReply(e.target.checked);
                                  props.onChange(e.target.checked);
                                }}
                                checked={awaitReply}
                              />
                              Esperar resposta
                            </label>
                            <FormTooltip text="Se estiver marcado, o próximo nó só será executado caso o usuário envie uma mensagem" />
                          </>
                        )}
                        defaultValue={awaitReply}
                      />
                    </div>
                  </>
                )}
                {[
                  'SEND_AWAIT',
                  'SUBMENU_BUTTONS',
                  'TRANSFER_TO_ATTENDANT',
                  'ET',
                  'EE',
                  'TTF'
                ].includes(actionType) && (
                  <>
                    <div
                      style={{
                        marginLeft: '1.3rem',
                        marginTop: '0.5rem',
                        marginBottom: '0.3rem'
                      }}
                    >
                      <Controller
                        name="mandatoryMessage"
                        control={control}
                        render={(props) => (
                          <>
                            <label className="form-control-label">
                              <Input
                                type="checkbox"
                                onChange={(e) => {
                                  setMandatoryMessage(e.target.checked);
                                  props.onChange(e.target.checked);
                                }}
                                checked={mandatoryMessage}
                              />
                              Desativar mensagem obrigatória
                            </label>
                            <FormTooltip text="Torna a mensagem deste nó opcional, permitindo prosseguir sem exibir texto obrigatório ao usuário." />
                          </>
                        )}
                        defaultValue={mandatoryMessage}
                      />
                    </div>
                  </>
                )}

                {!unallowedActionTypes.includes(actionType) && (
                  <Row className="mb-3">
                    <Col sm="12" className="tour5-dt">
                      <label className="form-control-label">
                        Mensagem a ser exibida ao usuário
                        {actionType === 'RP' ||
                        actionType === 'RETURN' ||
                        actionType === 'LINKMENU' ||
                        actionType === 'EXECUTE_INTEGRATION' ||
                        actionType === 'CREATE_PROTOCOL' ||
                        mandatoryMessage === true
                          ? ''
                          : '*'}
                        <FormTooltip text="Mensagem a ser exibida ao usuário." />
                      </label>
                      <Controller
                        as={
                          <Input
                            type="textarea"
                            rows="3"
                            placeholder="Mensagem a ser exibida ao usuário"
                          />
                        }
                        control={control}
                        name="message"
                        rules={
                          actionType === 'RP' ||
                          actionType === 'RETURN' ||
                          actionType === 'LINKMENU' ||
                          actionType === 'CHECK_CONDITIONAL' ||
                          actionType === 'EXECUTE_INTEGRATION' ||
                          actionType === 'CREATE_PROTOCOL' ||
                          mandatoryMessage === true
                            ? {}
                            : { required: 'Campo obrigatório!' }
                        }
                        defaultValue={
                          selectedNode?.action?.message &&
                          typeNodeAction === 'EDIT_NODE'
                            ? selectedNode?.action?.message
                            : ''
                        }
                      />
                      <ErrorMessage
                        errors={errors}
                        name="message"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </Col>
                  </Row>
                )}
                {actionType === 'EXECUTE_INTEGRATION' && (
                  <>
                    <Row style={{ marginLeft: '.1rem' }}>
                      <h4>Parâmetros:</h4>
                    </Row>
                    {params &&
                      params.map((data, i) => {
                        return (
                          <Row
                            style={{
                              alignItems: 'start',
                              marginBottom: '1rem'
                            }}
                            key={i}
                          >
                            <Col md="6" sm="6">
                              <label className="form-control-label">Nome</label>
                              <Input
                                control={control}
                                name="paramName"
                                value={data.paramName}
                                onChange={(event) =>
                                  handleChangeParams(i, event)
                                }
                              />
                            </Col>
                            <Col md="5" sm="5" style={{ paddingRight: '1rem' }}>
                              <label className="form-control-label">
                                Valor
                              </label>
                              <Input
                                control={control}
                                name="paramValue"
                                value={data.paramValue}
                                onChange={(event) =>
                                  handleChangeParams(i, event)
                                }
                              />
                            </Col>
                            <Col md="1" sm="1" style={{ paddingLeft: '0' }}>
                              <Button
                                size="md"
                                color="danger"
                                onClick={() => handleRemoveParams(i)}
                                style={{
                                  marginTop: '2.1rem'
                                }}
                              >
                                <li className="fas fa-trash"></li>
                              </Button>
                            </Col>
                          </Row>
                        );
                      })}
                    <Button
                      style={{ marginTop: '1rem' }}
                      outline
                      type="button"
                      color="light"
                      onClick={onAddParam}
                    >
                      Adicionar parâmetro <li className="fas fa-plus"></li>
                    </Button>
                  </>
                )}
                {actionType === 'CREATE_PROTOCOL' && (
                  <>
                    <Row style={{ marginLeft: '.1rem' }}>
                      <h4>Parâmetros do protocolo:</h4>
                    </Row>
                    <Row
                      style={{
                        alignItems: 'start',
                        marginBottom: '1rem'
                      }}
                    >
                      <Col md="12">
                        <label className="form-control-label">
                          Tipo de registro*
                        </label>

                        <Controller
                          render={() => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={getSelectOptionsDTO() || []}
                              isMulti={false}
                              closeMenuOnSelect={true}
                              value={selectedRecordType}
                              valueController={(name, value) => {
                                setSelectedRecordType(value ?? 1);
                              }}
                              fieldName="recordTypeId"
                              labelName="label"
                              valueName="value"
                            />
                          )}
                          control={control}
                          name="recordTypeId"
                          rules={{ required: 'Campo obrigatório!' }}
                          defaultValue={selectedRecordType ?? 1}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="recordTypeId"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        {selectedRecordType && (
                          <ProtocolFieldsBroadcastList
                            setValue={setValue}
                            control={control}
                            errors={errors}
                            selectedOption={actionType}
                            selectedRecordType={selectedRecordType}
                            watch={watch}
                            getValues={getValues}
                            isUpdate={
                              typeNodeAction === 'EDIT_NODE' ? true : false
                            }
                          />
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
              {actionType !== 'CONDITIONAL_CHECK' && (
                <Col
                  sm="6"
                  md="6"
                  style={{
                    borderLeft: '1px solid #e3e3e3'
                  }}
                >
                  <Row style={{ marginLeft: '.1rem' }}>
                    <h4>Variáveis:</h4>
                  </Row>

                  {fields &&
                    fields.map((data, i) => {
                      return (
                        <Row
                          style={{
                            alignItems: 'start',
                            marginBottom: '1rem'
                          }}
                          key={i}
                        >
                          <Col md="5" sm="5" className="tour4-dt">
                            <label className="form-control-label">
                              Nome
                              <FormTooltip text="As variáveis devem começar com cifrão. Ex.: $CPF, $RG" />
                            </label>
                            <Input
                              control={control}
                              name="name"
                              value={data.name}
                              onChange={(event) => {
                                handleChangeVariables(
                                  i,
                                  event.target.name,
                                  event.target.value
                                );
                              }}
                            />
                          </Col>
                          <Col md="5" sm="5" className="tour4-dt">
                            <label className="form-control-label">Valor</label>
                            <Controller
                              render={() => (
                                <div style={{ position: 'relative' }}>
                                  <Input
                                    control={control}
                                    name={`type${i}`}
                                    value={data.value}
                                    onChange={(event) => {
                                      handleChangeVariables(
                                        i,
                                        event.target.name,
                                        event.target.value
                                      );
                                      const value = event.target.value.trim();
                                      if (
                                        value === '' ||
                                        'null'.includes(value) ||
                                        'input.message'.includes(value)
                                      ) {
                                        setDropdownOpen(i);
                                      } else {
                                        setDropdownOpen(null);
                                      }
                                    }}
                                    onFocus={() => {
                                      setTimeout(() => {
                                        setDropdownOpen(i);
                                      }, 300);
                                    }}
                                    onBlur={() => {
                                      setTimeout(() => {
                                        setDropdownOpen(null);
                                      }, 200);
                                    }}
                                  />
                                  {data.value === 'input.message' && (
                                    <div style={{ fontSize: '12px' }}>
                                      {'Armazena a resposta do usuário'}
                                    </div>
                                  )}

                                  {data.value === 'null' && (
                                    <div style={{ fontSize: '12px' }}>
                                      {'Apaga o valor armazenado na variável'}
                                    </div>
                                  )}

                                  {dropdownOpen === i && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        backgroundColor: '#fff',
                                        // border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        boxShadow:
                                          '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        zIndex: 1000,
                                        maxHeight: '200px',
                                        overflowY: 'auto'
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          setDropdownOpen(null);
                                          handleChangeVariables(
                                            i,
                                            `type${i}`,
                                            'null'
                                          );
                                        }}
                                        style={{
                                          padding: '10px 0px 10px 0px',
                                          cursor: 'pointer',
                                          borderBottom: '1px solid #eee'
                                        }}
                                        onMouseEnter={(e) =>
                                          (e.currentTarget.style.backgroundColor =
                                            '#f5f5f5')
                                        }
                                        onMouseLeave={(e) =>
                                          (e.currentTarget.style.backgroundColor =
                                            '#fff')
                                        }
                                      >
                                        <Col>
                                          <div style={{ fontWeight: 'bold' }}>
                                            {'null'}
                                          </div>
                                          <div style={{ fontSize: '14px' }}>
                                            {
                                              'Apaga o valor armazenado na variável'
                                            }
                                          </div>
                                        </Col>
                                      </div>
                                      <div
                                        onClick={() => {
                                          handleChangeVariables(
                                            i,
                                            `type${i}`,
                                            'input.message'
                                          );
                                          setDropdownOpen(null);
                                        }}
                                        style={{
                                          padding: '10px 0px 10px 0px',
                                          cursor: 'pointer',
                                          borderBottom: '1px solid #eee'
                                        }}
                                        onMouseEnter={(e) =>
                                          (e.currentTarget.style.backgroundColor =
                                            '#f5f5f5')
                                        }
                                        onMouseLeave={(e) =>
                                          (e.currentTarget.style.backgroundColor =
                                            '#fff')
                                        }
                                      >
                                        <Col>
                                          <div style={{ fontWeight: 'bold' }}>
                                            {'input.message'}
                                          </div>
                                          <div style={{ fontSize: '14px' }}>
                                            {'Armazena a resposta do usuário'}
                                          </div>
                                        </Col>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                              control={control}
                              name={`type${i}`}
                              defaultValue={data.value}
                              rules={{
                                validate: () => {
                                  if (
                                    fields[i].name.length > 0 &&
                                    fields[i].type.length === 0
                                  ) {
                                    return 'Campo obrigatório';
                                  }
                                }
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name={`type${i}`}
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="1" sm="1" className="tour4-dt">
                            <Button
                              size="md"
                              color="danger"
                              onClick={() => handleRemoveFields(i)}
                              style={{
                                marginTop: '2rem'
                              }}
                            >
                              <li className="fas fa-trash"></li>
                            </Button>
                          </Col>
                        </Row>
                      );
                    })}
                  <Button
                    style={{ marginTop: '1rem' }}
                    outline
                    type="button"
                    color="light"
                    onClick={onAddField}
                  >
                    Adicionar variável <li className="fas fa-plus"></li>
                  </Button>
                </Col>
              )}
            </Row>

            {actionType !== 'CONDITIONAL_CHECK' && actionType !== 'ET' && (
              <>
                <Row>
                  <Col sm="12" className="tour5-dt">
                    <div
                      style={{
                        marginLeft: '1.3rem',
                        marginTop: '0.5rem',
                        marginBottom: '0.3rem'
                      }}
                    >
                      <Controller
                        name="chooseNodeQueue"
                        control={control}
                        render={(props) => (
                          <>
                            <label className="form-control-label">
                              <Input
                                type="checkbox"
                                onChange={(e) => {
                                  setChooseNodeQueue(e.target.checked);
                                  props.onChange(e.target.checked);
                                }}
                                checked={chooseNodeQueue}
                              />
                              Alterar fila deste nó
                            </label>
                            <FormTooltip text="Quando o usuário passar por este nó, será transferido para a fila que você selecionar." />
                          </>
                        )}
                        defaultValue={chooseNodeQueue}
                      />
                    </div>
                    {chooseNodeQueue === true ? (
                      <>
                        <label className="form-control-label">
                          Fila do nó*
                          <FormTooltip text="Quando o usuário passar por este nó, será transferido para a fila que você selecionar." />
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={queues}
                              isMulti={false}
                              closeMenuOnSelect={true}
                              value={props.value}
                              valueController={setValue}
                              fieldName="nodeQueue"
                              labelName="name"
                              valueName="id"
                            />
                          )}
                          control={control}
                          name="nodeQueue"
                          rules={{
                            required:
                              chooseNodeQueue == true
                                ? 'Campo obrigatório!'
                                : undefined
                          }}
                          defaultValue={
                            selectedNode?.queueId ?? selectedNode?.nodeQueue
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="nodeQueue"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </>
                    ) : null}
                  </Col>
                </Row>
                {allowedTypesToSendMedia.includes(actionType) && (
                  <Row className="mb-4">
                    <Col sm="12" className="tour5-dt">
                      <div
                        style={{
                          marginLeft: '1.3rem',
                          marginTop: '0.5rem',
                          marginBottom: '0.3rem'
                        }}
                      >
                        <Controller
                          name="sendMedia"
                          control={control}
                          render={(props) => (
                            <>
                              <label className="form-control-label">
                                <Input
                                  type="checkbox"
                                  onChange={(e) => {
                                    setChooseSendMedia(e.target.checked);
                                    props.onChange(e.target.checked);
                                  }}
                                  checked={chooseSendMedia}
                                />
                                Enviar arquivo de mídia
                              </label>
                              <FormTooltip text="Quando o usuário passar por este nó, será enviado a mídia que você selecionar." />
                            </>
                          )}
                          defaultValue={chooseSendMedia}
                        />
                      </div>
                      {chooseSendMedia === true ? (
                        <Form>
                          <FormGroup>
                            <label
                              htmlFor="download_media"
                              className="btn btn-primary btn-sm"
                              style={buttonStyle(
                                systemConfiguration.primary_color
                              )}
                            >
                              Selecionar um arquivo
                            </label>
                            <Input
                              style={{ display: 'none' }}
                              type="file"
                              id="download_media"
                              name="download_media"
                              accept=".csv, .xls, .xlsx, .pdf, .jpeg, .jpg, .mp4, .doc, .docx, .png, .mp3, .wav, .avi, .txt, .odt"
                              value={selectedFile?.file}
                              onChange={changeFile}
                            />
                          </FormGroup>
                        </Form>
                      ) : null}
                      {selectedFile?.name || selectedNode.filepath ? (
                        <div style={{ marginBottom: '24px' }}>
                          <div
                            style={{
                              marginBottom: '8px',
                              fontSize: '0.875rem'
                            }}
                          >
                            Arquivo
                          </div>
                          <div
                            style={{
                              color: '#525f7f',
                              fontSize: '1rem',
                              fontWeight: '600'
                            }}
                          >
                            <div
                              style={{
                                width: '40%',
                                marginBottom: '0.5rem'
                              }}
                            >
                              <FlexMediaPreviewer
                                file={selectedFile}
                                onFileResolved={setPreviewCover}
                              />
                            </div>
                            {selectedFile?.name || selectedNode.fileName}
                            <Button
                              size="md"
                              type="button"
                              color="danger"
                              title="Remover arquivo selecionado"
                              onClick={handleClearFiles}
                              style={{
                                marginLeft: '0.5rem'
                              }}
                            >
                              Limpar
                            </Button>
                          </div>
                        </div>
                      ) : null}
                    </Col>
                    {selectedFile && (
                      <Col md="3">
                        <label className="form-control-label">
                          Quando enviar
                          {previewCover ? '*' : ''}
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={whenToSendImageOptions}
                              isMulti={false}
                              isDisabled={
                                selectedFile && previewCover ? false : true
                              }
                              closeMenuOnSelect={true}
                              value={props.value}
                              valueController={setValue}
                              fieldName="whenToSend"
                              labelName="name"
                              valueName="id"
                            />
                          )}
                          control={control}
                          rules={{
                            required: previewCover ? 'Selecione uma opção!' : ''
                          }}
                          name="whenToSend"
                          defaultValue={
                            selectedNode.whenToSend
                              ? selectedNode.whenToSend
                              : ''
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="whenToSend"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    )}
                  </Row>
                )}
              </>
            )}
          </>

          <Button color="primary" onClick={handleOpenModalConfirmation}>
            Salvar
          </Button>
          <Button color="danger" onClick={() => onModalToggle(false)}>
            Cancelar
          </Button>
          {!selectedNode.isDefault && (
            <Button
              className="float-right "
              type="button"
              outline
              color="info"
              onClick={openTour}
              title="Saiba mais sobre as configurações do nó"
            >
              Saiba Mais
            </Button>
          )}
        </Form>
      </Modal>

      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={nodeValues}
        deleteResource={handleUpdateAccountsInBatch}
        message={
          '<h3 style="color:Tomato">Tem certeza que deseja continuar?</h3> \n <p>Todos os nós abaixo da condicional serão apagados.</p>'
        }
        messageContainsHtml={true}
      />

      <Tour steps={steps} isOpen={tourOpen} onRequestClose={closeTour} />
    </>
  );
};

export default DialogTreeModal;
